import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../../shared';

import { RepresentanteModalidadeComercialBadgeComponent } from './representante-modalidade-comercial-badge.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        RepresentanteModalidadeComercialBadgeComponent
    ],
    exports: [
        RepresentanteModalidadeComercialBadgeComponent
    ]
})
export class RepresentanteModalidadeComercialBadgeModule { }
